<template>
  <div class="q-mx-auto q-py-sm" style="max-width: 990px">
    <div class="row">
      <div
        class="col-md-6 col-12 text-subtitle1 text-bold q-pa-xs"
        :class="this.$q.dark.mode === true ? '' : 'text-primary '"
      >
        Floorsheet of {{ symbol }} on {{ selectedDate }}
      </div>

      <div class="col-md-6 col-12">
        <q-input
          dense
          outlined
          v-model="selectedDate"
          mask="date"
          :rules="['date']"
          class="text-bold"
        >
          <q-popup-proxy
            ref="qDateProxy"
            transition-show="scale"
            transition-hide="scale"
          >
            <q-date
              v-model="selectedDate"
              @input="() => $refs.qDateProxy.hide()"
              @update:model-value="loadData(selectedDate)"
            />
          </q-popup-proxy>
          <q-icon
            name="event"
            class="text-grey text-h6 date-icon cursor-pointer q-pt-md"
          />
        </q-input>
      </div>
    </div>

    <div class="q-px-xs text-body2 text-bold">Quantity Wise Filter</div>

    <div class="q-gutter-sm q-pa-sm">
      <q-radio
        dense
        keep-color
        color="primary"
        v-model="filterQuantity"
        val="default"
        label="Default"
      />
      <q-radio
        dense
        keep-color
        color="cyan"
        v-model="filterQuantity"
        val="quantity-ten"
        label="Qnty (0-10)"
      />
      <q-radio
        dense
        keep-color
        color="teal"
        v-model="filterQuantity"
        val="quantity-hundred"
        label="Qnty (10-100)"
      />
      <q-radio
        dense
        keep-color
        color="deep-purple"
        v-model="filterQuantity"
        val="quantity-thousand"
        label="Qnty (100-1000)"
      />

      <q-radio
        dense
        keep-color
        color="purple"
        v-model="filterQuantity"
        val="quantity-thousand-more"
        label="Qnty (1000 +)"
      />
    </div>

    <q-table
      flat
      bordered
      :rows="filterFloorSheetData"
      :columns="columns"
      binary-state-sort
      separator="cell"
      :pagination="{
        rowsPerPage: 500,
        sortBy: 'transaction',
        descending: true,
      }"
      :class="
        $q.dark.mode === true
          ? 'table-sticky-header-column-dark'
          : 'table-sticky-header-column'
      "
    >
      <template v-slot:top-left>
        <div class="row q-gutter-sm">
          <q-select
            :menu-absolute="true"
            outlined
            class="q-mb-sm ellipsis"
            :class="this.$q.dark.mode === true ? '' : 'bg-grey-1'"
            v-model.lazy="selectedBuyer"
            single
            dense
            clearable
            use-input
            input-debounce="0"
            :options="options"
            option-value="broker_no"
            option-label="broker_name"
            emit-value
            stack-label
            map-options
            label="Buyer"
            filter
            @filter="filterFn"
          >
            <template v-slot:option="scope">
              <q-item v-bind="scope.itemProps">
                <q-item-section avatar>
                  <q-item-label class="text-bold ellipsis">{{
                    scope.opt.broker_no
                  }}</q-item-label>
                </q-item-section>
                <q-item-section>
                  <q-item-label>
                    <div class="row">
                      {{ scope.opt.broker_name }}
                    </div>
                  </q-item-label>
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
              </q-item>
            </template>
          </q-select>
          <q-select
            :menu-absolute="true"
            outlined
            class="q-mb-sm ellipsis"
            :class="this.$q.dark.mode === true ? '' : 'bg-grey-1'"
            v-model.lazy="selectedSeller"
            single
            dense
            clearable
            use-input
            input-debounce="0"
            :options="options"
            option-value="broker_no"
            option-label="broker_name"
            emit-value
            stack-label
            map-options
            label="Seller"
            filter
            @filter="filterFn"
          >
            <template v-slot:option="scope">
              <q-item v-bind="scope.itemProps">
                <q-item-section avatar>
                  <q-item-label class="text-bold ellipsis">{{
                    scope.opt.broker_no
                  }}</q-item-label>
                </q-item-section>
                <q-item-section>
                  <q-item-label>
                    <div class="row">
                      {{ scope.opt.broker_name }}
                    </div>
                  </q-item-label>
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>
      </template>

      <template v-slot:top-right>
        <div class="q-mb-sm">
          <span class="q-mr-sm">
            Turnover :
            <span class="text-caption text-bold">
              {{ avgTotalVol?.turnover?.toFixed(2) }}
            </span>
          </span>
          <span class="q-mr-sm">
            Volume :
            <span class="text-caption text-bold">
              {{ avgTotalVol?.volume?.toFixed(2) }}
            </span>
          </span>
          <span class="">
            Avg Price :
            <span class="text-caption text-bold">
              {{ avgTotalVol?.rate ? avgTotalVol?.rate?.toFixed(2) : "" }}
            </span>
          </span>
        </div>
      </template>
      <template v-slot:bottom-row>
        <q-tr :class="$q.dark.mode === true ? '' : ' bg-grey-3'">
          <q-td colspan="1">Total</q-td>
          <td></td>
          <td></td>
          <q-td class="text-center">
            {{ sumBy(filterFloorSheetData, "quantity").toFixed(2) }}
          </q-td>
          <td></td>
          <q-td class="text-center">
            {{ sumBy(filterFloorSheetData, "amount").toFixed(2) }}
          </q-td>
        </q-tr>
      </template>
    </q-table>
    <div class="q-pa-lg flex flex-center">
      <q-pagination
        v-model="firstPage"
        :max="lastPage"
        :max-pages="6"
        boundary-numbers
      />
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watch, onUnmounted } from "vue";
import { useStore } from "vuex";
import useData from "src/use/data";
import versionTwo from "src/use/datav2";
import { LocalStorage, useQuasar } from "quasar";
import useMarket from "src/use/market";
import { sumBy, meanBy } from "lodash";

export default {
  name: "StockWiseFloorSheet",
  props: {
    symbol: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const store = useStore();
    const { floorsheetSearch, intradayFloorsheetSearch, brokerList } =
      useData();

    const { floorsheetBySymbol, floorsheetSum } = versionTwo();
    const selectedBuyer = ref(null);
    const selectedSeller = ref(null);
    const brokerLists = ref([]);
    const options = ref([]);

    const indexData = ref([]);
    const selectedDate = ref(store.state.market.asOf);
    const FloorSheetData = ref([]);
    const avgTotalVol = ref({});

    const isMarketOn = ref(LocalStorage.getItem("isMarketOn"));
    const filterQuantity = ref("default");

    brokerList().then((res) => {
      brokerLists.value = res.data;
    });

    const columns = [
      {
        name: "transaction",
        label: "Transaction",
        field: "transaction",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "left",
      },
      {
        name: "buyer",
        label: "Buyer",
        field: (row) => (!row.buyer ? "-" : row.buyer),
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "center",
      },
      {
        name: "seller",
        label: "Seller",
        field: (row) => (!row.seller ? "-" : row.seller),
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "center",
      },
      {
        name: "quantity",
        label: "Quantity",
        field: "quantity",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "center",
      },
      {
        name: "rate",
        label: "Rate",
        field: "rate",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "center",
      },
      {
        name: "amount",
        label: "Amount",
        field: "amount",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "center",
      },
    ];

    const lastPage = ref({});
    const firstPage = ref(1);
    const initialSize = ref(500);
    let intervalId = null;

    function loadData(date) {
      if (isMarketOn.value) {
        if (date === store.state.market.asOfLive.split("T")[0]) {
          floorsheetBySymbol(
            props.symbol,
            date.replaceAll("/", "-"),
            firstPage.value,
            initialSize.value
          ).then((res) => {
            FloorSheetData.value = res.data.data;
            lastPage.value = res.data.last_page;
          });
          handleSelected(null, null);
        } else {
          floorsheetBySymbol(
            props.symbol,
            date.replaceAll("/", "-"),
            firstPage.value,
            initialSize.value
          ).then((res) => {
            FloorSheetData.value = res.data.data;
            lastPage.value = res.data.last_page;
          });

          if (selectedBuyer.value !== null) {
            handleSelected("buyer", selectedBuyer.value);
          } else if (selectedSeller.value !== null) {
            handleSelected("seller", selectedSeller.value);
          } else {
            handleSelected(null, null);
          }
        }
      } else {
        floorsheetBySymbol(
          props.symbol,
          date.replaceAll("/", "-"),
          firstPage.value,
          initialSize.value
        ).then((res) => {
          FloorSheetData.value = res.data.data;
          lastPage.value = res.data.last_page;
        });

        if (selectedBuyer.value !== null) {
          handleSelected("buyer", selectedBuyer.value);
        } else if (selectedSeller.value !== null) {
          handleSelected("seller", selectedSeller.value);
        } else {
          handleSelected(null, null);
        }
      }
    }

    if (isMarketOn.value) {
      intervalId = setInterval(() => {
        if (selectedDate.value !== "") {
          loadData(selectedDate.value.replaceAll("/", "-"), props.symbol);
        }
      }, 20000);
    }

    const filterFloorSheetData = computed(() => {
      return FloorSheetData.value.filter((item) => {
        const filterBuyer =
          selectedBuyer.value === null ||
          item.buyer?.toLowerCase() === selectedBuyer.value;
        const filterSeller =
          selectedSeller.value === null ||
          item.seller?.toLowerCase() === selectedSeller.value;

        const quantityFilter =
          filterQuantity.value === "default" ||
          (filterQuantity.value === "quantity-ten" && item.quantity <= 10) ||
          (filterQuantity.value === "quantity-hundred" &&
            item.quantity > 10 &&
            item.quantity <= 100) ||
          (filterQuantity.value === "quantity-thousand" &&
            item.quantity > 100 &&
            item.quantity <= 1000) ||
          (filterQuantity.value === "quantity-thousand-more" &&
            item.quantity > 1000);

        return filterBuyer && filterSeller && quantityFilter;
      });
    });

    function loadSum(date, target, broker) {
      floorsheetSum(
        props.symbol,
        date.replaceAll("/", "-"),
        target,
        broker
      ).then((res) => {
        avgTotalVol.value.turnover = res.data?.a;
        avgTotalVol.value.volume = res.data?.q;
        avgTotalVol.value.rate = res.data?.a / res.data?.q;
      });
    }

    function handleSelected(target, newVal) {
      if (newVal === null) {
        loadSum(selectedDate.value.replaceAll("/", "-"), target, newVal);
      } else {
        loadSum(selectedDate.value.replaceAll("/", "-"), target, newVal);
      }
    }

    watch(selectedBuyer, (newVal, oldVal) => {
      handleSelected("buyer", newVal);
    });

    watch(selectedSeller, (newVal, oldVal) => {
      handleSelected("seller", newVal);
    });

    watch(props, (newProps, oldProps) => {
      loadData(selectedDate.value, newProps.symbol);
    });

    watch(firstPage, (page) => {
      firstPage.value = page;
      loadData(selectedDate.value, firstPage.value);
    });

    onMounted(() => {
      if (isMarketOn.value) {
        selectedDate.value = store.state.market.asOfLive.split("T")[0];

        if (selectedDate.value !== "") {
          loadData(selectedDate.value, props.symbol);
        }
      } else {
        selectedDate.value = store.state.market.asOf;

        if (selectedDate.value !== "") {
          loadData(selectedDate.value, props.symbol);
        }
      }
    });

    onUnmounted(() => {
      clearInterval(intervalId);
    });

    return {
      selectedDate,
      FloorSheetData,
      columns,
      loadData,
      indexData,
      firstPage,
      lastPage,
      selectedBuyer,
      selectedSeller,
      brokerLists,
      options,
      filterFloorSheetData,
      avgTotalVol,
      filterQuantity,
      sumBy,

      filterFn(val, update) {
        if (val === "") {
          update(() => {
            options.value = brokerLists.value;
          });
          return;
        }

        update(() => {
          const needle = val;
          options.value = brokerLists.value.filter((v) => {
            return (
              v.broker_name.toLowerCase().indexOf(needle) > -1 ||
              v.broker_no.toString().toLowerCase().indexOf(needle) > -1
            );
          });
        });
      },
    };
  },
};
</script>
